var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFadedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "246px",
    height: "146px",
    viewBox: "0 0 246 146",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Command Center") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iPad-No-Projects",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Empty-projects---iPad",
    transform: "translate(-125.000000, -334.000000)",
    fill: "#E5E5E5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.305024,334 L211.967092,368.21143 L187.114088,368.21143 L164.616006,406.987704 L186.510788,445.972171 L231.305024,445.972171 L254.303098,406.021674 L294,406.021674 L251.445921,480 L167.133838,480 L125,407 L167.133838,334 L231.305024,334 Z M328.565071,334 L371,407 L328.565071,480 L263.640064,480 L284.059482,444.82478 L308.70664,444.82478 L331.435774,406.068534 L308.70664,366.963134 L264.187972,366.963134 L241.310443,407 L202,407 L244.064057,334 L328.565071,334 Z",
    id: "Command-Center"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFadedIcon);
export default __webpack_public_path__ + "static/media/faded-icon.e57769561ffe8f412413d6302a530184.svg";
export { ForwardRef as ReactComponent };